import React from 'react'

export default function HeroSection({ project }) {
  return (
    <div>
      <div className="mx-auto max-w-7xl">
        <div className="relative z-10 pb-8 sm:pb-16 md:pb-20 lg:w-full lg:max-w-2xl lg:pb-28 xl:pb-32">
          <main className="mx-auto mt-10 max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div className="sm:text-center lg:text-left">
              <h1 className="text-4xl font-light tracking-tight sm:text-5xl md:text-6xl">
                <span className="block text-blue-900 xl:inline">Data Privacy Portal</span>
              </h1>
              <br />
              <h1 className="text-3xl font-light tracking-tight sm:text-3xl md:text-4xl">
                {
                  project ?
                    <img src={project.logo_url} alt={project.name} style={{ height: '5rem' }} />
                    :
                    <span className="block text-gray-400 xl:inline">{`{ for Your Company }`}</span>
                }
              </h1>
              <hr className="red-divider" />
              <p className="mt-3 text-base text-gray-500 sm:mx-auto sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0">
                Welcome to R2’s Data Subjects’ Rights (DSR) request portal. The purpose of this website is to provide a means to formally submit a Data Subject Right(s) request as defined by the General Data Protection Regulation (GDPR).
              </p>
              <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <div className="rounded-md shadow">
                  <a href="#" className="flex w-full items-center justify-center rounded-md border border-transparent bg-blue-900 px-8 py-3 text-base font-medium text-white hover:bg-blue-700 md:py-4 md:px-10 md:text-lg">Get started</a>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div className="lg:absolute lg:inset-y-100 lg:top-20 lg:right-0 lg:w-1/2 sm:flex sm:justify-center lg:flex lg:justify-center">
        <img src="images/DataPrivacy.png" className='lg:w-5/6' alt="" />
      </div>
    </div>
  )
}
